<template>
  <div class="sponsor" v-if="status">
    <p class="title">스폰서</p>

    <div class="swiper">
      <swiper ref="sponsorSwiper" :options="swiperOption" class="mySwiper">
        <swiper-slide
          v-for="(item, index) in list"
          :key="index"
          class="slide">
          <div class="bgBox">
            <img :src="item.image" :alt="item.name">
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>

import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css'

export default {
  name : 'Sponsor',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      status: false,
      swiperOption: {
        // slidesPerView: 3.1,
        slidesPerView : 'auto',
        spaceBetween: 13,
        centeredSlides: true,
        loop: true,
        loopAdditionalSlides : 1,
        autoplay: {
          delay: 2500,
          disableOnInteraction: true
        },
        breakpoints: {
          '960': {
            // slidesPerView: 3.2,
            // spaceBetween: 20,
          }
        }
      },
      // swiperPause: false,
      list: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init() {
      this.list = []

      const {data} = await this.$http.get('/notice/sponsor')
      if(data.success) {
        this.list = data.data

        this.list.map((item) => {
          item.image = 'https://www.dragons.co.kr/' + item.image
        })
      }
    },
    imageSrc(imgSrc) {
      return require('@/assets/img/sponsor/'+imgSrc);
    }
  }
}
</script>
<style scoped>
.swiper-container {
  padding-top: 15px;
}
</style>
